import { mapState } from 'pinia'
import { formatMoneyWithCurrency, NON_NUMERIC_NUMBER_DEFAULT } from '@/plugins/numformat'
import { useRootStore } from '@/store/root'
import { bgnToEur, CurrencyCode, currencyCodeToSymbol, getCurrencyCode } from '@/plugins/currencyFormatters'
import { isNil } from 'lodash'

const TARGET_CURRENCY_CODE = CurrencyCode.EUR

export default {
  computed: {
    ...mapState(useRootStore, ['locale', 'isBgMultiCurrencyActive'])
  },
  methods: {
    shouldFormatBGNToEuro (currency) {
      return this.isBgMultiCurrencyActive && currency === CurrencyCode.BGN
    },
    bgnToEuro (amount, currency) {
      if (this.shouldFormatBGNToEuro(currency)) {
        return bgnToEur(amount)
      }
      return null
    },
    getBgnInEuroFormat (bgnAmount, options = {}) {
      return this.getBgnInEuroFormatWithCurrency(bgnAmount, TARGET_CURRENCY_CODE, options)
    },
    getBgnInEuroFormatWithCurrency (bgnAmount, targetCurrencyCode, options = {}) {
      const euroAmount = isNil(bgnAmount) ? null : bgnToEur(bgnAmount)
      return formatMoneyWithCurrency(euroAmount, targetCurrencyCode, this.locale, options)
    },
    formatBGNToEuro (amount, currency, options = {}) {
      return this.shouldFormatBGNToEuro(currency)
        ? this.getBgnInEuroFormat(amount, options)
        : null
    },
    addDualCurrencyListItems (invoiceAmounts, currencyCode) {
      if (!this.shouldFormatBGNToEuro(currencyCode)) {
        return invoiceAmounts
      }

      const formatAmountOptions = { zeroAs: `${NON_NUMERIC_NUMBER_DEFAULT} ${currencyCodeToSymbol(TARGET_CURRENCY_CODE)}` }

      return invoiceAmounts.reduce((acc, invoiceAmountItem) => {
        invoiceAmountItem.css = 'f-color-navy'

        acc.push(invoiceAmountItem)

        acc.push({
          key: invoiceAmountItem.key + '-secondary',
          title: ' ',
          value: this.getBgnInEuroFormat(invoiceAmountItem.amount || 0, invoiceAmountItem.zeroAs ? formatAmountOptions : {})
        })

        return acc
      }, [])
    },
    getMonetaryLabelValues (amount, currency, options = {}) {
      const currencyCode = getCurrencyCode(currency, 'N/A')

      const values = []

      const secondaryValue = this.formatBGNToEuro(amount, currencyCode, options)

      const primaryValue = formatMoneyWithCurrency(amount, currencyCode, this.locale, options)

      values.push({
        text: primaryValue
      })

      if (secondaryValue) {
        values.push({
          text: secondaryValue,
          isSecondary: true
        })
      }

      return values
    },
    getSeparatedSecondaryAmount (amount, currencyCode) {
      if (!this.shouldFormatBGNToEuro(currencyCode)) {
        return null
      }

      const secondaryFormattedAmount = this.getBgnInEuroFormatWithCurrency(amount, null)

      return {
        formattedValue: secondaryFormattedAmount,
        currencyCode: TARGET_CURRENCY_CODE
      }
    }
  }
}
